var _defs, _image, _rect, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstructionsMobile02(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1200 1400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        filter: url(#drop-shadow-3);\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4 {\n        fill: #e31e26;\n      }\n\n      .cls-5 {\n        fill: #f9a51a;\n      }\n\n      .cls-6 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        filter: url(#drop-shadow-2);\n      }\n\n      .cls-7 {\n        fill: #d7e159;\n      }\n\n      .cls-8 {\n        fill: #edd8ce;\n      }\n\n      .cls-9 {\n        fill: #b2d236;\n      }\n\n      .cls-10 {\n        fill: #e88b24;\n      }\n\n      .cls-11 {\n        filter: url(#drop-shadow-4);\n      }\n\n      .cls-4 {\n        filter: url(#drop-shadow-1);\n      }\n\n      .cls-12 {\n        fill: #541334;\n      }\n\n      .cls-13 {\n        opacity: .23;\n      }\n\n      .cls-14 {\n        fill: #1f519e;\n      }\n\n      .cls-15 {\n        fill: #db3a5d;\n      }\n\n      .cls-16 {\n        fill: #0c192d;\n      }\n\n      .cls-17 {\n        fill: #e2dae5;\n      }\n\n      .cls-18 {\n        fill: #b5d348;\n      }\n\n      .cls-19 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-20 {\n        fill: #467e3b;\n      }\n\n      .cls-21 {\n        fill: none;\n      }\n\n      .cls-22 {\n        fill: #fcee4d;\n      }\n\n      .cls-23 {\n        fill: #fcc612;\n      }\n\n      .cls-24 {\n        fill: #612c85;\n      }\n\n      .cls-25 {\n        fill: #85b13f;\n      }\n\n      .cls-26 {\n        fill: #221f1f;\n      }\n\n      .cls-27 {\n        fill: #ee9f20;\n      }\n\n      .cls-28 {\n        fill: #d2ba9e;\n      }\n\n      .cls-29 {\n        fill: #f2f9fd;\n      }\n\n      .cls-30 {\n        fill: #4a256b;\n      }\n\n      .cls-31 {\n        fill: #6a4;\n      }\n\n      .cls-32 {\n        fill: #92c640;\n      }\n\n      .cls-33 {\n        fill: #faad3c;\n      }\n\n      .cls-34 {\n        fill: #839d59;\n      }\n\n      .cls-35 {\n        fill: #579542;\n      }\n\n      .cls-36 {\n        fill: #c4d94a;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-1",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-2",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-2",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-2",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-3",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-3",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-3",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 949.04,
    y: 447.13,
    width: 254.04,
    height: 379.37
  })), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-4",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur-4",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.75
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur-4",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _image || (_image = /*#__PURE__*/React.createElement("image", {
    width: 512,
    height: 512,
    transform: "translate(665.07 452.29) scale(.07)",
    xlinkHref: "C:\\\\\\\\Users\\\\\\\\visha\\\\\\\\Downloads\\\\\\\\logout.png"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: -2.25,
    y: -5.74,
    width: 1207.59,
    height: 1410.68
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M877.8,1151.32c26.24,30.14,91.62,59.47,185.73-22.03,18.03,.44-.46,69.79-84.31,82.41,50.58,11.06,110.09-48.5,124.88-35.04,10.55,10.74-20.56,78.21-127.36,59.77,23.37,12.32,70.54-1.05,77.17,17.44-32.05,39.55-169.17,14-221.99-101.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M875.76,1138.38c20.13,23.75,61.4,33.18,87.93,29.6-9.52,11.44-46.77,16.61-66.89,10.81,25.88,27.29,59.38,42.35,59.38,42.35-22.06,5.52-62.58-5.18-86.15-31.85,21.88,30.36,51.15,52.03,57.7,55.26-44.68-1.63-87.92-37.24-94.96-78.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M870.85,1155.01c21.31,11.18,54.86,17.67,54.86,17.67-42.05,1.61-69.3-10.52-69.3-10.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M868.8,1157.88c8.61,17.29,34.04,42.62,47.57,49.51-30.14-10.75-62.81-46.71-62.07-48.56,.74-1.84,5.54,45.64,35.72,67.12-30.98-19.59-45.97-48.07-45.36-67.35"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M945.61,1186.28c33.05-7.76,65.73-28.27,68.7-26.15,2.97,2.1,5.5,2.87,5.5,2.87,0,0-1.01-5.68,.83-7.62,13.72-14.8,40.39-29.3,44.18-25.54,4.92,13.59-23.11,49.96-49.32,61.45-4.66-.45-15.96-4.7-15.96-4.7l4.78,10.31c-14.09,10.04-42.72,6.4-51.26-1.24,36.64-10.01,75.09-25.83,95.56-44.49-46.26,25.45-74.81,34.79-103.02,35.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M984.58,1215.62c25.32-1.72,105.37-51.18,119.52-38.95,1.47,22.04-36.91,49.11-65.78,52.7-4.27-.49-12.67-6.7-12.67-6.7l2.88,9.58c-20.35,4.95-61.82-1.04-86.97-22.49,44.31,17.57,96.49,14.89,145.54-19.1-35.8,16.86-74.17,25.85-102.51,24.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M944.57,1229.69c23.78,3.16,99.09,7.64,108.48,22.36-3.47,10.26-49.72,14.23-63.13,10.85-3.54-3.67-7.99-11.87-7.99-11.87l-.29,9.59c-18.62-.4-54.01-17.34-69.57-38.45,32.61,24.12,82.75,30.92,119.07,30.05-39.79-5.83-86.58-22.52-86.58-22.52Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M507.05,962.98c-44.02-3.3-81.59,20.04-76.63,30.07,3.41,6.93,45.23-12.27,85.36,1.66,15.07,3.64,22.61-17.33,9.22-26.78-13.39-9.45-17.96-4.95-17.96-4.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M524.87,956.96c-37.1-30.19-69.07-19.7-69.85-30.41-.79-10.7,65.66-20.2,102.74,10.01"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M539.98,945.09c-41.97-26.28-128.19-5.02-131.54,31.07,24.97-8.79,65.21-19.48,106.59,1.76,25.83,8.14,35.13-26.48,24.96-32.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M618.99,967.72c-52.4-77.25-131.72-60.24-95.87-40.49-47.13-7.43-31.25,21.01,1.75,29.73-43.3-1.07-53.49,33.88-6.51,30.1-30.39,3.6-30.72,24.61,6.44,22.54,28.86,11.26,50.65,33.71,89.01,11.83,38.38-21.89,5.18-53.71,5.18-53.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M594.92,943.65c-26.59-26.82-66.2-35.17-77.99-24.19,9.34,10.54,38.06,10.83,68.33,35.15,1.54-2.46-10.16-18.35-34.28-28.87,20.32,4.77,40.41,24.14,43.95,17.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M568.73,953.94c-18.85-19.52-68.3-37.93-81.77-20.46,5.16,18.07,47.83,24.7,70.16,41.34-5.45-6.85,.52-15.42,.52-15.42-7.59-8.41-51.99-23-51.99-23,24.6-1.82,54.59,19.2,54.59,19.2,4.3-1.78,8.49-1.66,8.49-1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M539.38,968.42c-20.87-11.34-55.13,.46-49.97,12.09,5.18,11.63,28.81,2.18,36.81,6.24-4.24-4-2.73-7.63-2.73-7.63-8.46-1.18-26.16-.96-26.16-.96,9.67-6.25,29.03-3.3,29.03-3.3,5.92-3.37,13.02-6.43,13.02-6.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M527.73,993.23c-11.15-7.47-34.56,4.1-29.53,10.23,5.02,6.13,21.36,1.16,31.36,1.74-.5-3.21-2.73-5.54-2.73-5.54-5.47-2.13-20.13,.28-20.13,.28,6.54-4.94,21.03-6.71,21.03-6.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M487.53,986.43c-23.49,1.28-54.83,10.33-57.11,6.63-2.3-3.69,22.22-16.78,52.45-20.42-2.94,6.3,4.66,13.79,4.66,13.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M469.98,962.51c-20.7-3.79-58.15,10.24-64.56,18.98-7.41-11.89,46.18-45.97,91.51-32.29-6.92,1.8-10.72,5.29-10.72,5.29-10.55-4.65-36.13,2.92-36.13,2.92,9.34-.47,19.9,5.11,19.9,5.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M483.08,933.7c-15.97-2.19-29.74-3.08-28.06-7.14,1.68-4.03,23.27-7.68,42.28-3.61-12.84,.95-14.22,10.75-14.22,10.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M655.83,1089.73c-29.15,21.76-95.53-5.75-125.15-51.6-25.07-38.8,1.98-35.15,25.35-17.59-55.2-50.38-2.26-63.63,33.17-36.79-35.43-26.84-3.94-43.44,18.22-15.57-23.67-28.69,10.4-30.52,43.28,19.48,31.03,47.19,29.67,83.76,5.13,102.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M656.5,1085.06c-22.93,28.73-86.79,.82-114.1-31.32-26.34-30.97-3.24-29.18,30.41-11.34-21.22-17.07-35.11-39.29-31.46-46.87,4.12-8.53,27.93-3.4,59.59,17.82-14.96-13.77-36.02-30.1-28.79-37.77,7.23-7.69,35.61,31.33,35.61,31.33-14.53-18.94-17.86-39.78-9.49-38.45,33.14,5.24,85,83.08,58.25,116.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M650.18,1087.01c-20.49,15.94-93.47-1.82-61.84-30.85,31.62-29.04,85.99,12.1,61.84,30.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M595.24,1044.18c-11.45,8.76-38.6-14.93-27.12-24.27,11.46-9.33,50.8,6.16,27.12,24.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M584.56,1071.84c-8.99,2.26-39.83-10.91-30.96-22.73,8.87-11.79,48.07,9.58,32.89,21.78"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M650.37,1055.99c-5.22,5.07-20.82-9.3-14.85-14.84,5.98-5.58,20.08,9.78,14.85,14.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M622.38,1033.71c-4.71,1.92-17.82-6.08-11.17-11.21,6.63-5.1,18.55,8.2,11.17,11.21Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M736.63,1138.62c8.84,5.74-11.23,87.97-22.91,90.44-11.68,2.46-44.85-6.48-49.23,19.62,.26,3.81,2.44,6.53,5.15,6.91-1.14,.23-12.03,7.06-5.53,16.43,5.59,8.05,35.75-14.68,64.57-21.4,13.21-3.07,32.39,13.87,38.13,6.48,10.85-13.96-19.6-20.52-26.41-25.14-8.09-5.46,20.09-90.51,28.57-103.37"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M668.14,1265.55c2.43,5.19,19.31-7.27,33.76-14.85,14.43-7.58,27.46-13.18,40.25-7.09,12.79,6.1,21.24,14.47,23.5,6.56,2.75-9.55-18.36-13.79-27.89-16.2-9.53-2.41,3.54-56.9,12.01-77.67-4.27,2.3-12.4,4.05-12.4,4.05-5.52,20.17-10.78,72.33-28.33,71.75-17.54-.59-32.03-1.79-38.61,5.27-6.56,7.06-.73,13.58,4.78,8.78,5.49-4.8,18.04-4.57,23.39-4.36-17.31,5.5-29.84,10.77-31.06,15.42"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M659.66,1269.11c1.83,3.87,13.68-1.54,14.69-5.92,1.01-4.38-2.03-8.45-5.81-8.47-3.79-.02-10.87,10.12-8.87,14.38Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M663.3,1249.99c1.81,3.87,11.92-1.41,12.93-5.8,1.01-4.36-.27-8.56-4.05-8.59-3.79-.01-10.89,10.12-8.88,14.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M660.04,1266.75c.91,3.35,10.26-1.87,9.26-8.39-1-6.51-10.61,3.54-9.26,8.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M770.46,1252.46c-.9,4.37-13.48,3.44-15.4-.39-1.95-3.84,.07-8.84,3.69-10.23,3.64-1.36,12.67,5.81,11.71,10.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M769.59,1250.31c-.15,3.56-10.29,1.9-10.78-4.71-.48-6.61,10.97-.4,10.78,4.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M663.18,1246.44c.87,3.38,11.14-.04,10.14-6.55-1-6.52-10.86,3.81-10.14,6.55Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M762.53,1177.86c-.3,8.25-15.73,28.2-28.17,25.89-10.87-2.01-17.04-16.39-18.57-36.14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M719.75,1169.97c-3.91,9.81,.52,29.62,11.36,32.65,10.85,3.04,18.89-13.05,17.91-20.94-.96-7.9-27.46-16.26-29.27-11.71Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M792.72,900.74c-3.53,28.29,70.18,82.3,90.13,185.11,17.87,92.15-60.01,132.81-159.04,105.5-101.81-28.07-113.67-170.03-80.71-235.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M648.42,893.1c10.83,15.51-7.14,55.61-11.53,73.28-6.56,26.44,46.29,282.76,150.76,162.66,29.41-33.81,55.93-142.49,61.8-168.73-3.28-12.6-48.32-39.25-45.15-122.3"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M725.01,980.4c15.04,48.86,61.55,169.54,26.69,197.51-28.49,13.76-74.92-1.26-106.2-47.68-31.29-46.42-25.48-123.02-12.13-162.14,20.56-60.24,66.58-69.13,91.64,12.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M633.34,1017.61s-17.69,86,37.36,138.33c32.98,31.35,62.65,23.83,72.68,6.31,19.36-33.82-19.49-121.81-34.96-160.46-26.8-48.68-62.04-41.87-75.09,15.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M689.95,1087.29c18.06,8.72,64,84.37,11.44,72.12-52.56-12.24-67.05-61.15-61.52-73.39,5.53-12.23,24.43-11.13,50.08,1.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M726.7,1090.12c12.28,7.89,6.45,38.6-6.79,26.16-13.24-12.43-12.64-38.67,6.79-26.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M648.21,1058.46c12.75,3.34,23.5,19.27,5.91,19-17.57-.26-18.68-22.35-5.91-19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M692.75,1071.93c10.1,3.84,7.02,15.59-2.8,15.36-9.79-.23-7.31-19.23,2.8-15.36Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M834.7,1272.71c1.91,6.56,6.14,26.62-14.21,24.85-14.39-1.25-4.54-21.09-15.49-25.16-10.95-4.1-38.37,6.39-43.05,.65,.57-19.69,35.42-12.16,39.72-22.55,2.62-16.38,.83-39.79-3.07-61.6,4.57-1.68,8.94-4.18,12.91-7.33,4.27,33.85,12.14,67.13,20.1,70.13,8.56,3.54,40.98,15.83,30.18,31.4-10.8,15.56-24.8-10.13-27.1-10.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M828.83,1251.14c-7.8-3.34-11.17-37.97-16.24-70.44-2.98,2.49-6.2,4.6-9.57,6.28,5.99,25.64,8.63,53.01,6.22,66.05-4.46,4.33-26.82,4.16-37.13,7.33-10.32,3.18-3.75,9.35-1.12,10.14,8.84-5.88,37.89-9.05,42.79-2.63,6.07,7.96-1.49,26.8,12.68,24.83,16.77-2.33,.79-26.33,7.11-24.99,9.63,2.05,17.77,16.81,23.79,11.76,6.02-5.06,7.74-12.78-28.52-28.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M771.81,1262.08c3.16,1.36,5.08,5.94,3.34,8.25-1.74,2.31-14.28,3.83-14.63,1.99-.76-3.96,7.12-12.02,11.3-10.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M767.19,1262.88c-6.53,2.99-6.63,10.78,1.05,7.22,7.68-3.55,4.75-9.88-1.05-7.22Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M831.38,1286.98c-3.26-2.2-9.98-.54-11.32,2.45-1.91,4.27,4.08,14.36,6.31,13.33,4.78-2.2,10.29-12.23,5.01-15.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M832.71,1291.64c-.83,7.39-8.14,10.15-9.65,1.99-1.51-8.17,10.37-8.33,9.65-1.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M858.87,1273.78c-3.53-.4-8.34,2.41-8.55,5.11-.22,2.72,8.91,9.94,10.5,8.62,3.41-2.85,2.72-13.18-1.95-13.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M862.54,1277.88c1.33,6.1-3.5,9.27-7,3.09-3.52-6.19,5.86-8.32,7-3.09Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M835.97,1176.56c3.06,9.67-8.62,40.01-25.75,43.24-14.93,2.81-28.95-10.86-39.19-32.93"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M779.99,1183.35c-.97,13.18,13.44,32.58,25.76,30.55,10.7-1.77,14.03-25.4,9.47-34.06-4.56-8.66-34.78-2.63-35.23,3.51Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M729.02,691.38c17.44-.52,76.53-42.6,44.21-72.21,42.74,10.91,29.73,70.11,12.49,79.79,23.04,.67,30.63-24.79,25.7-36.23,30.65,21.34,9.17,53.21-7.64,59.19,13.68-3.73,33.03,11.03,32,30.27-5.76-8-25.11-2.26-25.11-2.26,15.14,54.41-10.58,104.79-1.73,137.88,10.09,37.71-145.42,63.41-164.8-9.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M805.08,822.29c24-57.61-24.28-143.24-104.69-137.93-83.44,5.51-90.13,91.93-97.92,117.81-24.79,38.24,14.06,77.53,53.58,77.51,50.58-.03,124.78,.8,149.03-57.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M708.49,686.05c56.71,4.25,79.81,65.53,76.35,98.17,3.04,10.61,13.25,67.95-39.69,81.28-55.43,13.95-96.16,8.69-130.56-12.33-30.38-18.57-14.65-39.91-9.17-52.09,13.12-75.8,43.19-119.55,103.07-115.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M692.14,691.83c68.54,4.36,66.73,102.34-15.14,104.68-75.65,2.17-57.89-109.32,15.14-104.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M779.51,626.95c31.23,2.88,24.63,64.92-24.68,54.95,16.34-4.54,33.32-39.76,24.68-54.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M814.02,670.53c12.64,5.17,8.15,53.25-24.7,32.3,23.67-6.33,24.7-32.3,24.7-32.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M803.17,726.2c16.65-5.72,27.61-4.63,29.81,18.76-8.63-15.1-26.42-6.38-29.81-18.76Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M693.54,795.62c-2.17-37.62,28.25-61.36,57.73-46.75,39.1,19.39,26.11,114.9-41.39,80.22"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M742.98,754c31.41,7.39,32.93,72.22-9.16,68.88-45.39-3.59-29.32-77.87,9.16-68.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M745.05,764.87c25.21,5.92,28.81,60.49-7.36,55.28-36.16-5.18-23.53-62.52,7.36-55.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M709.09,769.9c8.38-9.37,18.05,12.75,14.97,16.78-3.08,4.05-22.72-8.2-14.97-16.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M751.98,794.91c4.07,.01,5.15,8.52-.36,7.61-5.5-.95-4.21-7.62,.36-7.61Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M618.54,744.04c6.81-8.8,33.97-1.03,27.53,48.61-9.86,38.76-40.6,25.65-43.07,7.65,2.64-31.07,11-46.65,15.54-56.26Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M634.11,757.43c19,6.59,13.82,53.55-9.37,48.61-27.44-5.8-13.89-56.63,9.37-48.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M636.44,762.12c15.76,5.4,11.46,44.38-7.8,40.29-22.74-4.83-11.48-46.95,7.8-40.29Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M613.49,762.62c5.89-5.22,11.49,12.12,9.29,14.7-2.21,2.55-14.97-9.67-9.29-14.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M635.14,784.46c2.65,.39,2.87,6.44-.64,5.3-3.53-1.16-2.33-5.72,.64-5.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M711.87,822.65c1.23,1.31,2.82,3.38,3.5,6.2,1.57,6.54-3.03,11.68-10.71,22.98-11.94,17.57-10.76,19.78-16.99,24.01-3.42,2.33-11.6,7.88-20.63,4.97-5.02-1.62-10.53-5.91-11.92-11.81-2.27-9.6,7.48-18.65,14.37-25.04,6.78-6.29,20.13-16.49,42.38-21.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M678.22,846.45c-3.19,1.15-5.05,3.32-5.7,4.16-2.54,3.26-2.69,6.77-2.72,8.11-.2,7.09,4.96,11.84,5.84,12.63,2.68-1.31,7.03-3.89,10.59-8.67,1.86-2.5,7.25-9.73,4.46-14.1-2.19-3.43-8.45-3.58-12.47-2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M658.41,873.96c-.43,.42,9.95,19.36,22.84,20.62,19.6,1.91,46.26-36.12,38.68-66.28-4.39-17.48-21.78-28.16-22.78-27.37-.74,.59,3.68,10.43,10.74,19.14,2.9,3.58,6.02,6.68,5.95,11.28-.05,3.09-1.51,5.54-2.56,7.29-1.86,3.13-4.12,4.94-8.57,8.46-1.72,1.36-4.1,3.15-7.08,5.09-2.61,5.98-5.78,10.36-8.4,13.4-3.22,3.73-12.93,14.98-21.95,12.93-4.42-1-6.69-4.75-6.88-4.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M695.89,860.99c-.78,11.8-7.32,20.27-15.77,23.56-6.98,2.69-16.33-4.87-16.33-4.87,10.71,1.11,24.26-4.84,32.1-18.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M692.73,789.89c13.1,9.19,24.73,25.9,20.66,33.46-1.31,2.43-3.51,2.55-6.53,7.25-3.01,4.68-2.13,6.57-4.88,11.42-2.98,5.25-6.97,8.24-8.57,9.42-5.8,4.26-11.6,5.18-13.39,5.61-23.32,5.65-24.95,37.24-24.33,43.48-3.52,2.2-10.96-1.8-18.21-8.28,0,0-10.98-8.13-17.09-23.25-6.21-15.38-6.49-77.67,29.34-88.74,20.32-6.28,40.24,7.7,43,9.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M662.79,780.05c23.38-.84,39.62,29.36,35.26,51.78-3.27,16.73-17.59,18.83-30.57,22.89-14.24,4.46-13.75,32.72-22.23,35.82-8.09,2.97-22.04-22.18-24.29-33.02-4.56-22.03-4.56-75.8,41.83-77.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M683.86,814.93c4.13,1.93,12.68,10.18,5.82,13.24-6.91,3.09-8.75-14.61-5.82-13.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M636.16,802.25c8.17,2.14-2.3,32.94-8.8,33.59-9.97,1.02-9.91-38.48,8.8-33.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M754.15,974.34c-11.86,68.76,21.02,130.87,41.22,137.75,14.26,24.3,36.23,47.05,46.07,40.8,4.97,14.06,43.58,19.62,43.28-11.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M899.2,1103.32c43.91,15.62,88.67,2.31,86.41-9.28-1.55-8.01-49.48-.1-86.48-25.45-14.32-7.91-27.85,11.34-16.84,24.7,10.99,13.35,16.9,10.03,16.9,10.03Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M879.38,1104.48c29.35,41.08,64.84,39.3,62.66,50.41-2.18,11.12-72.49,2.29-101.84-38.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M860.67,1112.37c35.44,38.45,129.15,40.8,142.6,4.98-27.85,2-71.82,1.68-108.04-31.47-24.03-15.47-43.14,17.19-34.56,26.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M786.53,1067.34c31.84,93.24,117.36,98.01,86.34,67.91,45.93,20.69,37.68-12.71,6.51-30.77,43.79,13.15,63.9-19.61,15-28.83,31.95,4.79,38.15-16.51-.28-24.75-26.26-19.5-42.18-48.43-87.35-36.82-45.17,11.61-20.22,53.25-20.22,53.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M804.33,1098.55c19.62,34.71,57.62,54.24,72.69,46.35-6.57-13.35-35.75-21.64-59.79-54.83-2.25,2.09,5.24,21.52,26.88,38.95-19.38-10.52-34.45-35.83-39.78-30.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M833.87,1095.36c13.75,25.13,58.98,57.63,77.56,43.59-.22-19.85-41.82-38.48-59.92-61.63,3.64,8.49-4.83,15.55-4.83,15.55,5.39,10.68,46.54,37.9,46.54,37.9-25.54-5-50.25-34.76-50.25-34.76-4.87,.62-9.1-.66-9.1-.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M867.8,1088.78c18.1,17.37,56.26,14.87,54.24,1.61-2.04-13.29-28.73-10.24-35.75-16.61,3.2,5.25,.66,8.55,.66,8.55,8.29,3.55,26.37,8.25,26.37,8.25-11.58,3.68-30.47-4.72-30.47-4.72-6.97,1.79-15.05,2.92-15.05,2.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M886.55,1066.77c9.28,10.7,36.33,5.45,32.93-2.2-3.4-7.64-21.44-7.13-31.46-10.51-.39,3.41,1.24,6.41,1.24,6.41,4.97,3.69,20.57,5.31,20.57,5.31-8.02,3.21-23.28,.98-23.28,.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M925.6,1084.88c24.27,5.24,58.72,4.75,60.01,9.16,1.3,4.39-27.3,10.89-59.11,6.18,4.75-5.6-.91-15.34-.91-15.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M936.82,1114.13c20.02,9.62,62.07,5.75,71.02-1.36,4.23,14.18-59.83,33.96-102.18,7.41,7.55,.09,12.38-2.4,12.38-2.4,9.46,7.68,37.62,7.08,37.62,7.08-9.64-2.11-18.84-10.73-18.84-10.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M915.46,1139.83c15.65,6.66,29.41,11.41,26.58,15.07-2.83,3.64-25.84,1.35-44.05-8.09,13.35,2.59,17.47-6.98,17.47-6.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M784.22,929.05c35.73-14.03,94.45,36.24,111.85,91.18,14.71,46.48-11.81,35.24-30.72,10.87,42.19,66.66-4.35,60.97-32.95,23.76,27.28,44.17-3.09,46.04-17.91,11.49-1.18,41.67-34.06,35.19-54.68-28.14-18.46-56.7-5.66-97.34,24.43-109.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M779.14,926.22c43.25-20.99,90.46,34.52,109.34,74.84,18.2,38.87-4.84,30.62-34.13,3.09,16.86,23.29,24.82,49.78,18.98,56.48-6.56,7.54-29.4-4.32-55.71-34.73,11.38,18.18,28.3,40.68,18.79,46.48-9.5,5.82-27.53-41.81-27.53-41.81,1.66,22.27,4.39,33.37-4.16,36-17.35,5.37-53.24-45.02-46.89-97.92,5.32,24.66,25.3,45.06,25.3,45.06-17.56-29.99-24.61-77.5-4.01-87.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M794.63,928.31c26.5-6.96,89.98,40.56,47.22,55.62-42.76,15.06-78.45-47.44-47.22-55.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M830.18,992.69c14.76-3.75,31.27,30.51,16.26,34.81-15.01,4.31-46.75-27.06-16.26-34.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M852.03,970.27c9.67,1.54,34.13,27.12,20.62,34.91-13.51,7.78-42.69-29.25-22.88-34.79"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M781.57,958.34c7.18-2.76,16.35,17.66,8.24,20.58-8.11,2.92-15.42-17.83-8.24-20.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M799.5,991.59c5.37,.09,14.76,13.3,6.19,15.51-8.55,2.2-14.61-15.66-6.19-15.51Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M739.71,730.43c-29.49-.71-54.02,24.53-54.79,56.38-.77,31.85,22.52,58.24,52,58.96,29.49,.71,54.02-24.53,54.79-56.38,.77-31.85-22.51-58.24-52-58.96Zm-2.65,109.83c-26.67-.64-47.73-24.52-47.04-53.32,.69-28.81,22.88-51.64,49.55-50.99,26.67,.64,47.73,24.52,47.04,53.32-.69,28.81-22.88,51.64-49.55,50.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M616.86,836.72c-1.13,.74-5.01,.89-7.53,.45-28.41-4.97-38.07-25.69-38.33-53.11-.27-28.81,21.49-50.22,48.16-49.58,24.16,.58,36.41,18.61,39.35,43.72,.03,0,.06,0,.1,0,1.67,.02,3.42,.07,5.07,.38-2.82-28.28-17.32-48.94-44.39-49.6-29.49-.71-52.63,23.11-53.39,54.96-.77,31.85,12.98,54.3,43.3,58.75,2.54,.37,5.75,.23,7.56-.4-.12-1.81,.02-3.64,.1-5.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M690.22,769.21c-16.56-6.53-30.42-.89-30.56-.83l-2.76-6.51c.67-.28,16.56-6.86,35.91,.77l-2.59,6.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M787.01,769.5h27.58c.3,0,.55,.24,.55,.55v5.51c0,.53-.43,.96-.96,.96h-27.16v-7.02h0Z",
    transform: "translate(18.87 -19.09) rotate(1.38)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576.7,761.91l33.78,.56-2.22,7.04-33.67-.63c-1.4-.03-2.51-1.2-2.48-2.6l1.27,.29c.06-2.47,.85-4.72,3.32-4.66Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M620.32,813.67c1.35-3.16,2.1-7.31,3.89-10.51l-55.76-1.35c-.41,0-.75,.31-.76,.72-.39,16.32,12.66,29.88,29.15,30.28l3.17,.07s.05,0,.08,0l3.17,.08c4.91,.12,9.58-.95,13.71-2.94,.01-.37,.07-.74,.17-1.11,.14-.31,.28-.63,.42-.94-.02-.68,.11-1.36,.36-1.99,.23-4.32,.81-8.62,2.39-12.32Z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M425.26,1146.75c24.18,7.71,39.76,23.81,45.1,48.43,5.28,24.3-1.72,46.05-21.36,61.06-10.48,8.02-11.72,15.18-8.25,26,1.65,5.12,.55,5.85-4.74,4-17.33-6.03-34.76-11.84-51.92-18.32-29.15-11.02-45.92-41.23-40.16-71.49,5.76-30.27,32.56-52.29,63.58-52.25,6.04,.01,12,.73,17.74,2.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M372.91,1200.72c-3.74,0-6.79,3.02-6.79,6.74,0,3.72,3.05,6.74,6.79,6.74s6.79-3.02,6.79-6.74c0-3.72-3.05-6.74-6.79-6.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M406.66,1200.72c-3.74,0-6.79,3.02-6.79,6.74,0,3.72,3.05,6.74,6.79,6.74s6.79-3.02,6.79-6.74-3.05-6.74-6.79-6.74"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M440.41,1200.72c-3.74,0-6.79,3.02-6.79,6.74,0,3.72,3.05,6.74,6.79,6.74s6.79-3.02,6.79-6.74c0-3.72-3.05-6.74-6.79-6.74"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-19"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-6",
    cx: 1136.72,
    cy: 668.81,
    rx: 83.04,
    ry: 90.03
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1216.86,689.37c-3.95-3.92-10.31-3.35-13.66,.84-11.05,19.94-32.41,33.46-56.95,33.46-3.13,0-6.21-.23-9.22-.66l-35.62,23.05,7.04-34.45c-5.36-3.82-10.09-8.43-14.07-13.65-.02-.03-.04-.06-.07-.09-8.18-10.79-13.04-24.19-13.04-38.74,0-10.52,2.55-20.44,7.04-29.22,.04-.08,.09-.17,.13-.25,10.55-20.37,31.67-34.43,56.16-35.03,.28,0,.56-.02,.84-.02,.27,0,.53-.02,.8-.02,25.45,0,47.47,14.55,58.13,35.71,2.98,5.11,10.16,5.98,14.39,1.71l31.13-31.43c3.09-3.12,3.48-7.97,1-11.59-22.69-33.14-61.3-54.16-101.77-55.2-42-1.08-82.67,19.91-106.66,54.05-25.08,35.69-29.01,82.92-11.26,122.58,18.05,40.33,57.17,68.21,101.22,73.18,42.71,4.82,85.29-12.88,112.16-46.12,1.46-1.81,2.87-3.65,4.23-5.54,2.64-3.66,2.29-8.66-.92-11.84l-31.04-30.74Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1115.91,654.61c-3.34,0-6.07,2.7-6.07,6.03s2.72,6.03,6.07,6.03,6.07-2.7,6.07-6.03c0-3.32-2.72-6.03-6.07-6.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1146.07,654.61c-3.34,0-6.07,2.7-6.07,6.03s2.72,6.03,6.07,6.03,6.07-2.7,6.07-6.03c0-3.32-2.72-6.03-6.07-6.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M1176.24,654.61c-3.34,0-6.07,2.7-6.07,6.03s2.72,6.03,6.07,6.03,6.07-2.7,6.07-6.03c0-3.32-2.72-6.03-6.07-6.03"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstructionsMobile02);
export default __webpack_public_path__ + "static/media/Instructions- Mobile-02.0d94e0b932edbe2ce17f20db5fda40aa.svg";
export { ForwardRef as ReactComponent };